/**
 * v-[c|background-color|f]:[?value] = [?value]
 *
 * Цвет текста, заднего фона или svg элемента на основе существующих css переменных color
 */
export default Vue => {
  ['color', 'background-color', 'fill'].forEach(attr => {
    const handler = (el, { arg, value }) => {
      const val = value || arg || '';

      const color = val
        ? val.startsWith('#') || val.startsWith('rgb') ? val : `var(--color-${val})`
        : '';

      el.style[
        {
          color: 'color',
          'background-color': 'background-color',
          fill: 'fill',
        }[attr]
      ] = color;
    };

    Vue.directive(attr, {
      bind: handler,
      update: handler,
    });
  });
};
